import { Guid, IBaseModel } from '~/interfaces/base'
import emptyId from '~/statics/empty-id'

export class TaminBranch implements IBaseModel {
  id: Guid
  city: string
  name: string

  constructor() {
    this.id = emptyId
    this.city = ''
    this.name = ''
  }
}